// extracted by mini-css-extract-plugin
module.exports = {"container":"ColorPicker_container__349Rz","input":"ColorPicker_input__1Qkrd","placeholder":"ColorPicker_placeholder__3ORIH"};